module.exports = __webpack_public_path__ + "img/staff.ee880ab5.svg";